import React from 'react';
import{
    Row, Col,
    FormGroup, ControlLabel
} from 'react-bootstrap';
// react component that creates a dropdown menu for selection
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import Log from 'services/Log.jsx'



class Step2 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            planSelect: null,
            planError: null,
            bootstrapVersion: "",
            plans: []
        }
    }
    componentDidMount() {
      var plans = [];
      for (var i in this.props.plans) {
        var plan = this.props.plans[i];
        Log.debug(plan);
        plans.push({value: i, label: plan['title'] + " - $" + plan['price']});
      }
      this.setState({plans: plans});
    }
    isValidated(){
      Log.debug(this.state.planSelect);
      if (this.state.planSelect) {
        this.props.setProjectPlan(this.state.planSelect);
        return true;
      } else {
        this.setState({ planError: (<small className="text-danger">Please select a valid subscription plan</small>)});
        return false;
      }
    }
    render(){
        return (
            <div className="wizard-step">
                <h5 className="text-center">Select your subscription plan</h5>
                <Row>
                  <Col md={10} mdOffset={1}>
                      <FormGroup>
                          <ControlLabel>Plan <span className="text-danger">*</span></ControlLabel>
                          <Select
                              name="planSelect"
                              value={this.state.planSelect}
                              options={this.state.plans}
                              palceholder="plan"
                              onChange={(value) => this.setState({ planSelect: value})}
                          />
                        {this.state.planError}
                      </FormGroup>
                  </Col>
                </Row>
            </div>
        );
    }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/views/Forms/Wizard/Step2.jsx